import React, { FormEvent, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Btn, H3, H6, Image, P } from '../AbstractElements';
import { dynamicImage } from '../Utils';
import { Col, Form, FormGroup, Input, Label } from 'reactstrap';
import { CreateAccount, DontHaveAccount, EmailAddress, FacebookLink, ForgotPassword, LinkedIn, Password, RememberPassword, SignIn, SignInAccount, SignInWith, TwitterLink } from '../Utils/Constants';
import FeatherIconCom from '../Utils/CommonComponents/CommonIcons/FeatherIconCom';
import { postData } from '../CommonElements/Functions/PostGetFun';
import { setItem } from '../Utils/StorageHelper';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../redux-toolkit/store';
import { API } from '../api/API';
import { setUserData } from '../redux-toolkit/reducers/UserDatareducer';
import { saveUserDataSeparately } from '../Utils/saveUserDB';
import Dexie, { Table } from 'dexie';

export default function SignInForm() {
    localStorage.clear();
    const navigate = useNavigate();
    const [isPasswordVisible, setPasswordVisible] = useState(false);
    const [email, setEmail] = useState("Email");
    const [loginUser, setLoginUser] = useState({
        AppToken: '',
        data: {},
        employee: [],
        scope: [],
    });
    const [password, setPassword] = useState("Password");
    // if (!localStorage.getItem("serverUrl")) {
    //     const envUrl = process.env.REACT_APP_SERVER_URL;
    //     if (envUrl) {
    //         localStorage.setItem("serverUrl", envUrl);
    //     }
    // }
    localStorage.setItem("serverUrl", process.env.REACT_APP_SERVER_URL || "");

    const serverUrl = localStorage.getItem("serverUrl");
    // const serverUrl = useSelector((state: RootState) => state.serverConfig.serverUrl);
    const dispatch = useDispatch<AppDispatch>();
    const toggle = () => setPasswordVisible(!isPasswordVisible);

    const handleSubmit = async (e: FormEvent) => {
        toast.success( "Login request sent!");
        e.preventDefault();
        await Dexie.delete('DynamicDB');
        localStorage.removeItem('schema_Employee')
        const url = `${serverUrl}${API.login}`;
        const { status, data } = await postData(url, false, {
            username: email,
            password: password,
        });

        console.log("Full API response:", data);

        if (status === 200 && data.data?.AppToken) {
            const token = data.data.AppToken;

            localStorage.setItem("isLoggedIn", 'true');
            localStorage.setItem("appToken", token);

            // Normalize employee: API may return an array or a single object
            const rawEmployee = data.data?.employee;
            const employee = Array.isArray(rawEmployee) ? rawEmployee[0] : rawEmployee;

            // console.log("AppToken:", token);
            console.log("Login Data:", data.data);
            // console.log("Employee Data:", employee?.EmployeeId);
            // console.log("Position Data:", employee?.PositionId);

            if (employee?.EmployeeId) localStorage.setItem("empId", String(employee.EmployeeId));
            if (employee?.PositionId) localStorage.setItem("positionId", String(employee.PositionId));
            if (employee?.OrgUnitId) localStorage.setItem("orgUnitId", String(employee.OrgUnitId));
            if (employee?.EmployeeCode) localStorage.setItem("employeeCode", String(employee.EmployeeCode));
            toast.success(data.message || "Login Success...!");
            navigate(`/firstLoader`);
        } else {
            toast.error(data.message || "Invalid username or password");
        }

    };

    return (
        <div>
            <div>
                <Link className='logo' to={`/admin`}>
                    <Image
                        className="img-fluid for-light"
                        src={dynamicImage(`logo/logo-1.png`)}
                        alt="loginpage"
                        style={{ width: '200px' }}
                        body={true}
                    />
                </Link>
            </div>
            <div className="login-main border shadow">
                <Form className="theme-form" onSubmit={handleSubmit}>
                    <H3>{SignInAccount}</H3>
                    <P>{"Enter your email & password to login"}</P>
                    <FormGroup>
                        <Col><Label>{EmailAddress}</Label></Col>
                        <Input type="email" placeholder='Enter your email' onChange={(event) => setEmail(event.target.value)} />
                    </FormGroup>
                    <FormGroup>
                        <Col><Label>{Password}</Label></Col>
                        <div className="form-input position-relative">
                            <Input type={isPasswordVisible ? 'text' : 'password'} placeholder='Enter your password' onChange={(event) => setPassword(event.target.value)} name="login[password]" />
                            <div className='show-hide' onClick={toggle}>
                                <span className={!isPasswordVisible ? 'show' : ''}></span>
                            </div>
                        </div>
                    </FormGroup>
                    <div className="mb-0 form-group">
                        {/* <div className="checkbox p-0">
                            <Input id="checkbox1" type="checkbox" />
                            <Label className="text-muted" htmlFor="checkbox1">{RememberPassword}</Label>
                        </div>
                        <Link className="link" to={`/auth/forget-password`}>{ForgotPassword}</Link> */}
                        <div className="text-end mt-3">
                            <Btn color='primary' className="btn-block w-100">{SignIn}</Btn>
                        </div>
                    </div>
                    {/* <H6 className="text-muted mt-4 or">{SignInWith}</H6> */}
                    {/* <div className="social mt-4">
                        <div className="btn-showcase">
                            <Link to="https://www.linkedin.com/login" className='btn btn-light me-1' target='_blank'>
                                <FeatherIconCom className='txt-linkedin' iconName='Linkedin' /> {LinkedIn}
                            </Link>
                            <Link to="https://twitter.com/login?lang=en" className='btn btn-light m-0' target='_blank'>
                                <FeatherIconCom className='txt-twitter' iconName='Twitter' /> {TwitterLink}
                            </Link>
                            <Link to="https://www.facebook.com/" className='btn btn-light' target='_blank'>
                                <FeatherIconCom className='txt-fb' iconName='Facebook' /> {FacebookLink}
                            </Link>
                        </div>
                    </div> */}
                    {/* <P className="mt-4 mb-0 text-center">{DontHaveAccount}
                        <Link className="ms-2" to={`/auth/sign-up`}>{CreateAccount}</Link>
                    </P> */}
                </Form>
            </div>
        </div >
    )
}
